angular.module('tgaAdmin')
  .controller('HubGameSettingsModalController', [
    '$scope', '$state', '$filter', '$window', '$uibModalInstance', '$uibModalStack',
    'customFieldService', 'tzService', 'scormService', 'extras',
    function (
      $scope, $state, $filter, $window, $uibModalInstance, $uibModalStack,
      customFieldService, tzService, scormService, extras,
    ) {
      $scope.showComingTooltip = $filter('translate')('modal.show_coming_tooltip');
      $scope.data = {
        alerts: [],
        closeButton: extras.closeButton,
        disable_featured: extras.items_featured >= 3 && !extras.game.is_featured,
        activityTypes: [
          { id: 'pdf', name: 'PDF' },
          { id: 'image', name: 'Image' },
          { id: 'video', name: 'Video' },
          { id: 'link', name: 'URL' },
          { id: 'audio', name: 'Audio' },
        ],
        dataTypes: [
          { id: 'iframe', name: 'Arcade (iframe)' },
          { id: 'external', name: 'New browser tab' },
        ],
        hubId: extras.hubId,
        updateTabName: 'Update File',
        activities: extras.activities,
      };

      $scope.viewmodel = {
        game: angular.copy(extras.game),
        // OAT-219 & OAT-220: Allow editing of scorm and task types (pdf,image,video,url).
        file_type: null,
        name: null,
        data: null, // holds base64 data for pdf
        data_type: null, // one of dataTypes
        activity_type: null, // one of activityTypes
        file: null, // holds scorm data
        locking_activity: {},
      };

      $scope.initialize = function () {
        // Parse date to user's timezone
        if ($scope.viewmodel.game.start_date) {
          $scope.viewmodel.game.start_date = tzService.parseUserDate($scope.viewmodel.game.start_date);
        }

        if ($scope.viewmodel.game.end_date) {
          $scope.viewmodel.game.end_date = tzService.parseUserDate($scope.viewmodel.game.end_date);
        }

        $scope.viewmodel.game.coming_soon = !!$scope.viewmodel.game.coming_soon;

        if ($scope.viewmodel.game.activity_type === 'game' && $scope.viewmodel.game.game_type === 'scorm') {
          $scope.viewmodel.file_type = 'scorm';
        } else if ($scope.viewmodel.game.activity_type === 'pdf') {
          $scope.viewmodel.file_type = 'pdf';
          $scope.data.updateTabName = 'Update PDF';
        } else if ($scope.viewmodel.game.activity_type === 'image') {
          $scope.viewmodel.file_type = 'image';
          $scope.data.updateTabName = 'Update Image';
        } else if ($scope.viewmodel.game.activity_type === 'video') {
          $scope.viewmodel.file_type = 'video';
          $scope.data.updateTabName = 'Update Video';
        } else if ($scope.viewmodel.game.activity_type === 'audio') {
          $scope.viewmodel.file_type = 'audio';
          $scope.data.updateTabName = 'Update Audio';
        } else if ($scope.viewmodel.game.activity_type === 'link') {
          $scope.viewmodel.data = $scope.viewmodel.game.data;
          $scope.viewmodel.data_type = $scope.viewmodel.game.data_type;
          $scope.viewmodel.file_type = 'link';
          $scope.data.updateTabName = 'Update URL';
        }

        $scope.viewmodel.name = $scope.viewmodel.game.name;
        $scope.actions.setLockingActivity();
      };

      $scope.actions = {
        submit(form) {
          form.submitted = true;

          $scope.actions.clearAlerts();

          if (form.$invalid) {
            return;
          }

          // Date gets set to `true` when you clear the field
          if ($scope.viewmodel.game.start_date === true) {
            $scope.viewmodel.game.start_date = null;
          }

          if ($scope.viewmodel.game.end_date === true) {
            $scope.viewmodel.game.end_date = null;
          }

          // Convert date back to UTC for storing in the database
          if ($scope.viewmodel.game.start_date) {
            $scope.viewmodel.game.start_date = $scope.viewmodel.game.start_date.utc().format();
          }

          if ($scope.viewmodel.game.end_date) {
            $scope.viewmodel.game.end_date = $scope.viewmodel.game.end_date.utc().format();
          }

          if ($scope.viewmodel.game.tile_color && $scope.viewmodel.game.tile_color.length !== 7) {
            $scope.viewmodel.game.tile_color = null;
          }

          // OAT 219-220: Allow for new scorm or PDF file here.
          if ($scope.viewmodel.file_type === 'scorm') {
            if ($scope.viewmodel.file && !$scope.viewmodel.file.$error) {
              // A new scorm game was specified.
              $scope.loading = true;
              $uibModalStack.getTop().value.backdrop = 'static';
              $uibModalStack.getTop().value.keyboard = false;

              scormService.upload({
                hub_id: $scope.data.hubId,
                name: $scope.viewmodel.name,
                files: [$scope.viewmodel.file],
                update_game: $scope.viewmodel.game.game_id, // flag that indicates to backend we are updating the file.
              }).then((resp) => {
                $scope.loading = false;
                delete $scope.viewmodel.name;
                delete $scope.viewmodel.file;
                const data = { ...$scope.viewmodel.game, ...resp.data };
                $uibModalInstance.close(data);
              }).catch((error) => {
                $scope.loading = false;
                $scope.actions.createAlert(
                  `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                  'danger',
                );
              });
            } else {
              // This is a scorm upload and the file was not saved. Maybe the name changed?
              const data = { ...$scope.viewmodel.game, name: $scope.viewmodel.name };
              $uibModalInstance.close(data);
            }
          } else if ($scope.viewmodel.file_type === 'video'
            || $scope.viewmodel.file_type === 'image'
            || $scope.viewmodel.file_type === 'pdf') {
            const data = {
              ...$scope.viewmodel.game,
              name: $scope.viewmodel.name,
              data: $scope.viewmodel.data,
            };

            $uibModalInstance.close(data);
          } else if ($scope.viewmodel.file_type === 'link') {
            const data = {
              ...$scope.viewmodel.game,
              name: $scope.viewmodel.name,
              data: $scope.viewmodel.data,
              data_type: $scope.viewmodel.data_type,
            };

            $uibModalInstance.close(data);
          } else {
            $uibModalInstance.close($scope.viewmodel.game);
          }
        },
        removeImage() {
          $scope.viewmodel.image = null;
          $scope.viewmodel.game.tile_image = null;
        },
        removeBanner() {
          $scope.viewmodel.image = null;
          $scope.viewmodel.game.banner_image = null;
        },
        checkImage(image) {
          $scope.actions.clearAlerts();

          if (!image) {
            $scope.actions.createAlert('<span class="fa fa-exclamation-triangle"></span> Invalid file format.', 'danger');
            return;
          }

          const extension = /(?:\.([^.]+))?$/;
          const ext = extension.exec(image.filename)[1];
          const allowed = /jpeg|jpg|gif|png|svg|pdf|mpg|mpeg|mp4|avi/i;
          if (!allowed.test(ext)) {
            image.base64 = null;
            image = null;
            $scope.actions.createAlert('<span class="fa fa-exclamation-triangle"></span> Invalid file format.', 'danger');
            return;
          }

          // Don't allow images larger than 10MB.
          if (image.filesize > 10485760) {
            image.base64 = null;
            image = null;
            $scope.actions.createAlert(
              '<span class="fa fa-exclamation-triangle"></span> Image files cannot be more than 10 MB in size.',
              'danger',
            );
          }
        },
        forceHex() {
          if ($scope.viewmodel.game.tile_color[0] !== '#') {
            $scope.viewmodel.game.tile_color = `#${$scope.viewmodel.game.tile_color}`;
          }
        },
        videoEmbed(item) {
          if (item.data.includes('vimeo')) {
            // eslint-disable-next-line max-len
            const result = item.data.match(/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_-]+)?/i);
            item.data = `https://player.vimeo.com/video/${result[1]}`;
          } else if (item.data.includes('youtu')) {
            if (!item.data.includes('embed')) {
              const expr = /(youtu\.be\/|[?&]v=)([^&]+)/;
              item.data = `https://www.youtube.com/embed/${item.data.match(expr)[2]}`;
            }
          }
        },
        createAlert(msg, type) {
          $scope.data.alerts = [];
          $scope.data.alerts.push({
            msg,
            type,
          });
        },
        clearAlerts() {
          $scope.data.alerts = [];
        },
        filterActivities(item) {
          const activities = $scope.data.activities.filter(
            () => item.activity_type !== $scope.viewmodel.game.activity_type
              || item.course_group_id === $scope.viewmodel.game.course_group_id,
          );

          return activities.length === 0;
        },
        setLockingActivity(event) {
          const activities = $scope.data.activities.filter((activity) => activity.activity_type !== 'game');
          if (!$scope.viewmodel.game.is_locked && !event) {
            $scope.viewmodel.locking_activity = {};
          } else if (event) {
            $scope.viewmodel.locking_activity = activities.filter(
              (activity) => activity.course_group_id === parseInt(event.target.value.match(/\d+/)[0], 10),
            );
          } else {
            $scope.viewmodel.locking_activity = activities.filter(
              (activity) => activity.course_group_id === $scope.viewmodel.game.locked_by_course_group_id,
            );
          }
        },
        updateModelLockFields() {
          $scope.viewmodel.game.locked_by_course_group_id = $scope.viewmodel.locking_activity[0].course_group_id;
          $scope.viewmodel.game.is_locked = 1;
        },
        removeModelLockFields() {
          $scope.viewmodel.game.locked_by_course_group_id = null;
          $scope.viewmodel.game.is_locked = 0;
          $scope.actions.setLockingActivity();
        },
        close() {
          $uibModalInstance.dismiss();
        },
      };
      $scope.initialize();
    },
  ]);
